import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { BtnPrimary } from "@/components/Buttons";
import { BrowserMockup } from "@/components/BrowserMockup";
import { FEATURES, IMAGES } from "@/lib/data";
import ExamplesCarousel from "@/components/ExamplesCarousel";

export default function Funcionalidades() {
  return (
    <>
      <section className="relative overflow-hidden pt-36 md:pt-44">
        <div className="pointer-events-none absolute left-[-8%] top-4 h-[420px] w-[420px] rounded-full bg-lightblue opacity-20 blur-[130px]" />
        <div className="mx-auto max-w-[1440px] px-6 pb-16 md:px-12">
          <Reveal>
            <span className="text-xs font-medium uppercase tracking-[0.28em] text-grad">Possibilidades</span>
            <h1 className="mt-5 max-w-4xl font-display text-5xl font-extrabold leading-[0.98] tracking-tight text-ink sm:text-6xl lg:text-7xl text-balance">
              O que o seu website <span className="text-grad">pode incluir</span>
            </h1>
            <p className="mt-7 max-w-xl text-lg leading-relaxed text-muted-foreground">
              Estes são exemplos das funcionalidades que conseguimos criar. Escolhemos juntos as que
              fazem sentido para o seu negócio — o seu website terá exatamente o que precisar.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-[1440px] px-6 md:px-12">
        <div className="ring-grad grid items-center gap-10 rounded-[2rem] bg-tint p-8 md:grid-cols-2 md:gap-16 md:p-12">
          <Reveal>
            <span className="text-xs font-medium uppercase tracking-[0.25em] text-grad">Um website completo</span>
            <h2 className="mt-4 font-display text-3xl font-semibold leading-[1.08] tracking-tight text-ink sm:text-4xl">
              Tudo num só sítio — e feito à sua medida
            </h2>
            <p className="mt-5 max-w-md text-lg leading-relaxed text-muted-foreground">
              Escolhemos consigo as funcionalidades certas para o seu negócio. Nada a mais, nada a menos
              — só o que faz sentido para si e para os seus clientes.
            </p>
          </Reveal>
          <Reveal delay={1}>
            <BrowserMockup src={IMAGES.uiAlt} alt="Exemplo de um website moderno com várias funcionalidades" />
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-[1440px] px-6 py-24 md:px-12 md:py-32">
        <Reveal className="mb-12">
          <span className="text-xs font-medium uppercase tracking-[0.25em] text-grad">E ainda mais</span>
          <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight text-ink sm:text-5xl">Todas as possibilidades</h2>
          <p className="mt-4 max-w-xl text-muted-foreground">Uma amostra do que é possível. Se não vir aqui o que precisa, pergunte — quase de certeza que conseguimos.</p>
        </Reveal>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
          {FEATURES.map((f, i) => {
            const Icon = f.icon;
            return (
              <motion.div
                key={f.title}
                initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }} transition={{ duration: 0.45, delay: (i % 4) * 0.05 }}
                className="group flex items-center gap-3 rounded-xl border border-line bg-gradient-to-r from-indigo-50 to-cyan-50 px-4 py-4 transition-[box-shadow,border-color,transform] duration-300 hover:-translate-y-0.5 hover:border-transparent hover:shadow-[0_18px_40px_-24px_rgba(23,21,15,0.3)]"
              >
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-grad text-white shadow-md">
                  <Icon className="h-4.5 w-4.5" style={{ width: 18, height: 18 }} strokeWidth={1.7} />
                </span>
                <span className="text-sm font-medium text-ink">{f.title}</span>
              </motion.div>
            );
          })}
        </div>
        <ExamplesCarousel />
        <div className="mt-16 flex flex-col items-start gap-6 rounded-[2rem] bg-ink p-10 text-white md:flex-row md:items-center md:justify-between md:p-14">
          <div>
            <h3 className="font-display text-3xl font-semibold md:text-4xl">Imagine o que o seu website pode fazer.</h3>
            <p className="mt-3 max-w-md text-white/70">Diga-nos o que precisa e mostramos-lhe o que é possível.</p>
          </div>
          <BtnPrimary to="/contacto">Fale connosco</BtnPrimary>
        </div>
      </section>
    </>
  );
}
